import { render } from "./IconCheckbox.vue?vue&type=template&id=ab0d97ce"
import script from "./IconCheckbox.vue?vue&type=script&lang=js"
export * from "./IconCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/js/components/Icons/Icons/24/IconCheckbox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ab0d97ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ab0d97ce', __exports__)) {
    api.reload('ab0d97ce', __exports__)
  }
  
  module.hot.accept("./IconCheckbox.vue?vue&type=template&id=ab0d97ce", () => {
    api.rerender('ab0d97ce', render)
  })

}


export default __exports__